import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Modal as BsModal,
  ModalBody,
  ModalTitle,
} from 'react-bootstrap'

export function Modal({ data, show, toggleModal }) {
  // NOTE: this hook has to run before the `data` guard below. Modal stays mounted
  // while `data` is undefined, so returning early first changed the hook count
  // between renders and React threw on the first click.
  const [selectedFlag, setSelectedFlag] = useState()

  if (data === undefined) return null

  return (
    <BsModal show={show} size="lg">
      <BsModal.Header className="d-flex">
        <ModalTitle>
          {data.user_info.first_name} {data.user_info.last_name}
        </ModalTitle>
        <Button
          className="ml-auto"
          onClick={() => {
            toggleModal()
            setSelectedFlag()
          }}
        >
          <i className="fa-solid fa-times"></i>
        </Button>
      </BsModal.Header>
      <ModalBody>
        <div className="d-flex">
          <div className="d-flex flex-column">
            {data &&
              data.rules_violated.map(item => (
                <Button
                  key={item.name}
                  className="btn btn-myed btn-default btn-default-myed m-3 p-3"
                  onClick={() => setSelectedFlag(item)}
                >
                  <h5>{item.name}</h5>
                  <span
                    className={`me-badge-tint me-badge-tint-${
                      item.severity === 'warning'
                        ? 'warning'
                        : item.severity === 'critical'
                        ? 'danger'
                        : 'neutral'
                    }`}
                  >
                    {item.severity}
                  </span>
                </Button>
              ))}
          </div>
          <div className="m-3">
            {selectedFlag && <FlagDetail flag={selectedFlag} />}
          </div>
        </div>
      </ModalBody>
    </BsModal>
  )
}

/**
 * Renders one violation.
 *
 * Preferred display is the flag's prebuilt `html` report, sanitized server-side in
 * ExcelAddInRule.get_matches_json_for_activity before it reaches here.
 *
 * The JSON dump is a fallback for submissions recorded BEFORE the add-in started
 * sending `html` - those flags carry only `raw_display`, and without this they would
 * render blank. Not an alternate view: whichever of the two is shown, it is the only
 * thing shown. Once no live data predates the html reports, this branch can go.
 */
function FlagDetail({ flag }) {
  if (flag.html) {
    return (
      <div
        className="maxw-675px"
        style={{ width: '675px' }}
        dangerouslySetInnerHTML={{ __html: flag.html }}
      />
    )
  }
  return (
    <pre className="maxw-675px" style={{ width: '675px' }}>
      {JSON.stringify(flag, null, 4)}
    </pre>
  )
}

FlagDetail.propTypes = {
  flag: PropTypes.object.isRequired,
}

Modal.propTypes = {
  data: PropTypes.object,
  show: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
}
